import { LedByUnion } from '../../../ContractCategoryDetails/types'
import { ROLES } from '../../../Permission'
import { LED_BY_VALUE } from '../../../../components/LeadByIndicator/constants'

const GpoRolesPermissions: string[] = [
  ROLES.GPO_PRESIDENT,
  ROLES.GPO_FINANCE_OFFICER,
  ROLES.GPO_ANALYST,
  ROLES.GPO_CONTRACT_STEWARD
]

const CommonsRolesPermissions: string[] = [
  ROLES.COMMONS_VICE_PRESIDENT,
  ROLES.COMMONS_CONTRACT_STEWARD,
  ROLES.COMMONS_ANALYST
]

export const checkShowPayorRecipientPopover = (
  userRole: string,
  isInvoices: boolean,
  ledBy?: LedByUnion
) => {
  if (
    userRole === ROLES.COMMUNITY_PRESIDENT &&
    ledBy === LED_BY_VALUE.COMMUNITY &&
    isInvoices
  )
    return true
  if (
    GpoRolesPermissions.includes(userRole) &&
    ledBy === LED_BY_VALUE.NATIONAL_GPO &&
    isInvoices
  )
    return true
  if (CommonsRolesPermissions.includes(userRole) && !isInvoices) return true
  return false
}
